import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.png";
import Particle from "../Particle";
import Home2 from "./Home2";

import Button from "react-bootstrap/Button";


function Home() {

 

  const handleClick = () => {
    window.open("https://www.favrhood.com/", "_blank", "noopener,noreferrer");
  };

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "700px" }}
              />Choicest Fruit<span className="small-r-symbol">®</span>{" "}              
              </h1>

              <h1 className="heading-name">
                <i>Knowledge and Technology
                  <strong className="main-name"> Serving the Welfare of Humanity</strong></i>
                
              </h1>
             
              
            </Col>
          
          
          </Row>
        </Container>
        
      </Container>
     <Button
    
  onClick={handleClick}
  variant="warning"
  size="lg"
  style={{
    color: "black",
    fontWeight: "bold",
    borderRadius: "0.5rem",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    padding: "0.75rem 1.5rem",
    backgroundColor: "#facc15", // Tailwind yellow-400
    border: "none"
  }}
   className="custom-yellow-btn"
>
  Join Favrhood - Our Community Platform for Local Innovation
</Button>

      <Home2 />
    </section>
  );
}

export default Home;
